import axiosInstance from "utils/axios-request";
import {gatewayUrl} from "config";

export enum RequestPath {
    START = "start",
    UPLOAD = "upload",
    COMPLETE = "complete",
}

export const getInstitutions = () => {
    return axiosInstance.request({
        baseURL: gatewayUrl,
        url: "bs-service/institutions",
        method: "post",
        data: {
            handler: "institutions",
        },
    });
};

export const requestBsUpload = (
    path: string,
    data: object,
    ) => {
    return axiosInstance.request({
        baseURL: gatewayUrl,
        url: `bs-service/${path}`,
        method: "post",
        data,
        timeout: 90000,
    });
};
